import { Label } from '@primer/react';
import { PropTableValues } from "../../../../src/components";
import { actionMenuOverlaySides } from '@primer/react-brand';
import * as React from 'react';
export default {
  Label,
  PropTableValues,
  actionMenuOverlaySides,
  React
};